import * as React from 'react';
export const DZSvg = React.forwardRef(function DZSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M8 2v12h6.002A2.005 2.005 0 0 0 16 11.991V4.01C16 2.899 15.113 2 14.002 2H8Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M1.998 2A2.005 2.005 0 0 0 0 4.009v7.982C0 13.101.887 14 1.998 14H8V2H1.998Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M10.655 6.602a2.42 2.42 0 0 0-1.922-.935c-1.325 0-2.4 1.044-2.4 2.333 0 1.289 1.075 2.333 2.4 2.333a2.42 2.42 0 0 0 1.922-.935 3 3 0 1 1 0-2.796ZM10 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8v1h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8v1h6Z',
      }),
    ),
  );
});
DZSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var DZ = {
  category: 'flag',
  colorable: false,
  name: 'DZ',
  svg: DZSvg,
};
